import { IApprovalDocumentMasterRegistrationType, IApprovalDocumentMasterRegistrationTypePayload } from 'pages/ApprovalDocumentGroup/ApprovalDocumentMasterRegistration/type';

export const types = {
  SAVE_APPROVAL_DM_RESGIS_SETTINGS: 'SAVE_APPROVAL_DM_RESGIS_SETTINGS' as const,
  SAVE_EXTENDED_INFO: 'SAVE_EXTENDED_INFO' as const,
  SAVE_PASS_APPROVAL_LIST: 'SAVE_PASS_APPROVAL_LIST' as const,
};

export const saveApprovalDocumentMasterRegistrationSettings = (payload: IApprovalDocumentMasterRegistrationTypePayload | undefined) => ({
  type: types.SAVE_APPROVAL_DM_RESGIS_SETTINGS,
  payload,
});
export const saveExtendedInfo = (payload: any) => ({
  type: types.SAVE_EXTENDED_INFO,
  payload,
});
export const savePassOfList = (payload: any) => ({
  type: types.SAVE_PASS_APPROVAL_LIST,
  payload,
});

export type Actions = (
  | ReturnType<typeof saveApprovalDocumentMasterRegistrationSettings>
  | ReturnType<typeof saveExtendedInfo>
  | ReturnType<typeof savePassOfList>
);
